import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader';

function BadParamsContent() {
  const params = new URLSearchParams(window.location.search);
  return (
    <div>
      <Helmet>
        <title>DISGENET: Page Not Found</title>
        <meta name="description" content="Invalid search parameters." />
      </Helmet>
      <CommonHeader />
      <div className="notFoundPage">
        {/* <h1>404</h1> */}
        <h2>Page Not Found</h2>
        <p>Invalid search parameters</p>
        <p>Check the spelling of your shared link and try again</p>
      </div>
      {/* <div className="notFoundPage">
        <h1>Error</h1>
        <h2>Error: Invalid Parametersss</h2>
        <p>
          {location}
          {params &&
            Array.from(params.keys()).map((key, index) => (
              <span key={index}>
                {key}: {params.get(key)}
                <br />
              </span>
            ))}
        </p>
      </div> */}
    </div>
  );
}

export default BadParamsContent;
